import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertToDate = ({ date, time }) =>
  dayjs(`${date}T${time}`).toDate();

export const getDateFromDateTime = ({ dateString }) =>
  dateString.split('T')[0];

// The backend sends hour-only offsets (`2026-10-08T12:00:00-03`), which Date.parse doesn't accept everywhere.
export const parseDateTimeWithOffset = (dateTimeString) => {
  if (!dateTimeString) {
    return null;
  }

  const normalized = dateTimeString.replace(/([+-]\d{2})$/, '$1:00');
  const parsed = dayjs(normalized);

  return parsed.isValid() ? parsed.toDate() : null;
};
